<template>
    <div>
        <div v-if="season">
        <div class="g_desktopOn sheaderClassement">
            <div style="margin-left:10px">
            <div style="float:right;height: 25px">
                <s-button v-if="season.state!='FINISH'" theme="is-success" label="Cloturer la saison" @onclick="confirmCloturer=true" :role="role"/>&nbsp;
                <s-button @onclick="onexport" label="Exporter" theme="is-primary"  icon="file-excel"/>
                &nbsp;<s-button theme="is-warning"
                            label="Modifier"
                            icon="edit"
                            @onclick="openModalTournoisSaison=true"
                            :role="role"/>
                <div style="padding: 10px" v-show="season.state!='FINISH'" >
                
                
               
            </div>
            </div>
            <div class="title is-4" > <s-button icon="list" theme="is-warning" @onclick="close" label=""/> {{club.name}}
                <div class="title is-5" style="width: 100%">
                    <s-l v-show="season.state!='FINISH'" id="classement_title_provisoire" :v="season.nom">Classement provisoire de la saison  %v</s-l> 
                    <s-l v-show="season.state=='FINISH'" id="classement_title_provisoire" :v="season.nom">Classement final de la saison %v</s-l>
                    <div style="float:right" v-if="classements" class="ligneNbTournois">
                        <span v-if="classements[0]">
                            <span v-if="season.tolerance!=0">{{season.tolerance}} concours retenus sur </span>
                            {{season.tournois.length}}
                            <span v-if="season.tolerance==0">
                                concours
                            </span>
                        </span>
                    </div>
                </div>
            </div>
          
                
            </div>
            
        </div>
        
         <div class="g_menuMobile">
             <table class="g_menuFooterMin">
                 <tr>
                     <td colspan="5" class="g_headerFooter">
                          <span v-show="season.state!='FINISH'">
                            <s-l id="classement_title_provisoire" :v="season.nom">Classement provisoire : %v</s-l>
                        </span>
                        <span  v-show="season.state=='FINISH'">
                            <s-l id="classement_title_provisoire" :v="season.nom">Classement final : </s-l>
                        </span>
                     </td>
                 </tr>
                 <tr>
                     <td>
                         <s-button theme="is-light"
                            label="Concours"
                            icon="list"
                            @onclick="close()"
                            mode="V"
                        />
                     </td>
                    <td>
                           <s-button 
                            @onclick="onexport" 
                            label="Exporter" 
                            theme="is-light"  
                            icon="file-excel"
                            mode="V"/>
                        
                     </td>
                     <td>
                         
                         <s-button :theme="tolerance ? 'is-success' : 'is-dark'"
                            :label="tolerance ? 'Tolerance' : 'tolerance'"
                            :icon="tolerance ? 'hand-scissors' : 'hand-spock'"
                            @onclick="tolerance=!tolerance;initClassement()"
                            mode="V"    
                        />
                     </td>
                      <td>
                         
                         <s-button theme="is-warning"
                            label="Modifier"
                            icon="edit"
                            @onclick="openModalTournoisSaison=true"
                            mode="V"/>
                      
                         
                     </td>
                     <td>
                      
                        <s-button theme="is-success" label="Cloturer" @onclick="confirmCloturer=true" icon="check"
                        mode="V"/>
                        
                     </td>
                 </tr>
             </table>
         </div>
          <s-confirm
                :open="confirmCloturer"
                @yes="cloture"
                @no="confirmCloturer=false"
          >
            Souhaitez vous réellement cloturer la saison ?
          </s-confirm>
          <s-modal 
                :open="openClassement"
                :title="titleClassement"
                :close="true"
                @close="openClassement=false"
            > 
                <div  v-if="classementSelected!=null" >
                    <div v-for="tournoi in classementSelected.tournois" class="classementJoueur" >
                        <div :class="classHeader(tournoi)"> {{formatDate(tournoi.date)}} 
                            <span v-show="!tournoi.present" style="float:right">
                            Absent
                            </span>
                            <span v-show="!tournoi.calcul" style="float:right">
                            Non pris en compte&nbsp;
                            </span>
                        </div>
                        
                        <table border="1" style="width:100%" :class="classTableau(tournoi)">
                            <tr >
                                <th>Classement</th>
                                <th>Parties gagnées</th>
                                <th>Parties perdues</th>
                                <th>Parties en egalité</th>
                                <th>Points</th>
                                 <th>Goal Average</th>
                            </tr>
                            <tr>
                                <th><span v-show="tournoi.present">{{tournoi.rang}}</span></th>
                                <th><span v-show="tournoi.present">{{tournoi.nbPartieGagne}}</span></th>
                                <th><span v-show="tournoi.present">{{tournoi.nbPartiePerdu}}</span></th>
                                <th><span v-show="tournoi.present">{{tournoi.nbPartieEgalite}}</span></th>
                                <th>{{tournoi.points}}</th>
                                <th>{{tournoi.diff}}</th>
                            </tr>
                        </table>
                    </div>
                </div>
            </s-modal>
        <div class="array_classement">
             <table border="1" width="100%" class="headerTable">
            <tr>
                <th width="10%"  rowspan="2"></th>
                <th align="center" colspan="2"  width="20%" rowspan="2">
                    Nom
                </th >
                <th align="center"  colspan="5">
                    <span class="g_mobileOn">
                    Sur  
                    </span>
                    <span v-if="season.tolerance==0">{{season.tournois.length}}</span>
                    <span v-if="season.tolerance!=0">{{season.tolerance}}</span>
                    <span class="g_desktopOn">
                    concours retenus
                    </span>
                </th>
                <th align="center"  colspan="2" class="totalHeader">
                    <span class="g_desktopOn">
                        Total des {{season.tournois.length}} concours
                    </span>
                    <span class="g_mobileOn">
                        Sur  {{season.tournois.length}}
                    </span>
                </th>
                </tr>
                <tr>
                     <th align="center"  width="10%">
                     <span class="g_desktopOn" >Présents</span>
                    <span class="g_mobileOn" >P</span>
                </th>
                 <th align="center"  width="10%">
                    <span class="g_desktopOn" >Gagnées</span>
                    <span class="g_mobileOn" >G</span>
                </th>
                <th align="center"  width="10%">
                     <span class="g_desktopOn" >Points</span>
                    <span class="g_mobileOn" >Pts</span>
                </th>
                <th align="center"  width="10%">
                     <span class="g_desktopOn" >Goal average</span>
                    <span class="g_mobileOn" >GA</span>
                </th>
                <th align="center"  width="10%">
                     <span class="g_desktopOn" >% Gagnés</span>
                    <span class="g_mobileOn" >%</span>
                </th>
                <th align="center"  width="10%" class="totalHeader">
                  <span class="g_desktopOn" >Présences</span>
                  <span class="g_mobileOn" >P</span>
                </th>
                <th align="center"  width="10%" class="totalHeader">
                  <span class="g_desktopOn" >Points</span>
                  <span class="g_mobileOn" >Pts</span>
                </th>
                </tr>
             </table>
        <table border="1" width="100%" class="classementFinal">
            <tr class="ligneClassement" v-for="(classement, index) in classements"  v-on:click="openModalClassement(classement)">
               
                <td width="10%" align="center">
                    {{classement.classement}}
                </td>
                <td width="20%" align="center" colspan="2" class="nomprenom">
                    {{classement.nom}}  {{classement.prenom}}
                </td>
                 <td  width="10%" align="center" v-if="season!=null">
                    {{classement.nbTournois}}
                </td>
                
                 <td width="10%" align="center">
                    {{classement.nbPartieGagne}}
                </td>
                <td width="10%" align="center" >
                    {{classement.points}}
                </td>
                <td width="10%" align="center" >
                    {{classement.diff}}
                </td>
                 <td width="10%" align="center" >
                    {{Math.round((classement.nbPartieGagne / (classement.nbPartieGagne + (isNaN(classement.nbPartieEgalite) ? 0 : classement.nbPartieEgalite) + classement.nbPartiePerdu)*100))}} %
                </td>
                 <td  width="10%" align="center" v-if="season!=null" class="ligneTotal">
                    {{classement.nbTournoisTotal}}
                </td>
                 <td  width="10%" align="center" class="ligneTotal">
                    {{classement.pointsReel}}
                </td>
            </tr>
        </table>
         </div>
         </div>
         <add-season 
                :open="openModalTournoisSaison" 
                :club="club" 
                @close="openModalTournoisSaison=false;initClassement()" 
                :saison="season"
            />
    </div>
</template>
<style scoped>
.ligneTotal {
    background-color: gray;
    color: white;
    border: black thin solid;
}
.totalHeader {
    background-color: black;
}
.ligneNbTournois {
    font-size: 16px;
    margin-top: 10px;
}
.sheaderClassement {
         position: fixed;
         z-index:3;
         top: 55px;
         padding-top: 10px;
         padding-left: 10px;
         padding-right: 10px;
         background-color: white;
         width: 100%;
     }


    @media screen and (max-width: 420px) {
         .podiumOff {
             visibility: hidden;
             display: none;
         }
         .headerTable th {
            color: white;
            height: 10px;
            font-size: 10px;
        }
         .array_classement {
            display: inline-flex;
            height: 90%;
            width: 100%;
            overflow-x: auto;
            margin-top: 10px;
            margin-bottom: 120px;
        }
        .headerTable {
            position: fixed;
            z-index:3;
            top: 60px;
            width: 100%;
            box-shadow: 0px 7px 7px -5px rgba(0,0,0,0.71);
            -webkit-box-shadow: 0px 7px 7px -5px rgba(0,0,0,0.71);
            -moz-box-shadow: 0px 7px 7px -5px rgba(0,0,0,0.71);
            background-color: var(--bluebg);
            color: white; 
        }
         .classementFinal tr td {
             padding: 5px;
             font-size: 8px;
        }
     }
     @media screen and (min-width: 420px) {
         .podiumOff {
             
         }
          .headerTable th {
            color: white;
            height: 25px;
            vertical-align: middle;
        }
         .headerTable {
            position: fixed;
            z-index:3;
            top: 140px;
            width: 100%;
            box-shadow: 0px 7px 7px -5px rgba(0,0,0,0.71);
            -webkit-box-shadow: 0px 7px 7px -5px rgba(0,0,0,0.71);
            -moz-box-shadow: 0px 7px 7px -5px rgba(0,0,0,0.71);
            background-color: var(--bluebg);
            color: white; 
        }
         .array_classement {
            display: flex;
            margin-top: 120px;
        }
         .classementFinal tr td {
             padding: 5px;
        }
     }
     
    
    .displayListTournoi {
        position: absolute;
        left: 10px;
        top: 100px;
        background-color: white;
        border: thin black solid;
        padding: 5px;
    }
    .ligneClassement {
        color: black;
    }
    .ligneClassement:nth-child(odd) {
        background-color: rgb(248, 244, 238);
    }
    .ligneClassement:hover {
        background-color: rgb(213, 240, 191);
        cursor: pointer;
    }
    .headerClassement {
        background-color: var(--bluebg);
        color: white;
        padding: 5px;
    }
    .headerNotCalcul {
        background-color: #c03820;
        color: white;
        padding: 5px;
    }
    .headerNotPresent {
        background-color: #4b4c50;
        color: white;
        padding: 5px;
    }
    .tableauClassement {
        background-color: #d7ddf1;
        
    }
    .tableauNotCalcul {
        background-color: #eec3bb;
        
    }
    .tableauNotPresent {
        background-color: #b7b7b8;
        
    }
    .classementJoueur {
        margin-bottom: 10px;
    }
    .tableau tr th  {
        text-align: center;
    }
    .nomprenom {
        text-overflow: ellipsis;
    }
</style>
<script>
import club_fct from "@/firebase/club.js"
import saison_fct from "@/firebase/season.js"
import navbarTournoi from "@/views/tournoi/navbar.vue"
import AddSeason    from '@/views/season/addSeason.vue'
import XLSX from 'xlsx'
export default {
    data() {
        return {
            club: null,
            classements: null,
            season: null,
            classementSelected: null,
            openClassement: false,
            tolerance: false,
            openModalTournoisSaison: false,
            confirmCloturer: false
        }
    },
    components: {
        navbarTournoi,
        AddSeason
    },
    computed: {
        
        titleClassement: {
            get() {
                if (this.classementSelected !=null) 
                    return this.classementSelected.nom + ' ' + this.classementSelected.prenom;
                else
                    return "";
            }
        },
        role: {
            get() {
            var idUser = this.$store.getters.getUser.authId;
            if (this.club!=null) {
                if (typeof(this.club.users) != "undefined")
                    if (typeof(this.club.users[idUser]) == "undefined"){
                        return "player"
                    }
                    else {
                        
                        return  this.club.users[idUser].role;
                    }
                }
            }
        }
    },
    
    mounted() {
      this.initClassement();  
    },
    methods: {
         async onexport () { // On Click Excel download button
           
            // export json to Worksheet of Excel
            // only array possible
            var prepareClassement = [];
            this.classements.forEach((element, indiceElement) => {
                var elementPrepare = {};
                if (typeof(element.classement)=="undefined")
                    elementPrepare.CLASSEMENT = indiceElement + 1;    
                else
                    elementPrepare.CLASSEMENT = element.classement;
                elementPrepare.NOM = element.nom;
                elementPrepare.PRENOM = element.prenom;
                elementPrepare.NBTOURNOIS = this.season.tournois.length;
                elementPrepare.PRESENTS = element.nbTournois;
                elementPrepare.GAGNES = element.nbPartieGagne;
                elementPrepare.POINTS = element.points;
                elementPrepare.GOALAVERAGE = element.diff;
                prepareClassement.push(elementPrepare);
            });
            

            var classements = XLSX.utils.json_to_sheet(prepareClassement) 

            const event = new Date();
            const options = {  year: 'numeric', month: 'long', day: 'numeric' };
            var nameFile = this.club.name + "-" + this.season.nom + "-classement-"+event.toLocaleDateString('fr-FR', options) + ".xlsx";
            
            

            // A workbook is the name given to an Excel file
            var wb = XLSX.utils.book_new() // make Workbook of Excel

            // add Worksheet to Workbook
            // Workbook contains one or more worksheets
            XLSX.utils.book_append_sheet(wb, classements, 'classements de la saison') // sheetAName is name of Worksheet

            // export Excel file
            XLSX.writeFile(wb, nameFile) // name of the file is 'book.xlsx'
        },
        classHeader(tournoi) {
            if (tournoi.calcul && tournoi.present)
                return "headerClassement";
            else if (!tournoi.calcul)
                return "headerNotCalcul";
            else 
                return "headerNotPresent";
            
        },
        classTableau(tournoi) {
            if (tournoi.calcul && tournoi.present)
                return "tableau tableauClassement";
            else if (!tournoi.calcul)
                return "tableau tableauNotCalcul";
            else return "tableau NotPresent";
                
        },
        initClassement() {
            this.classements = [];
            var idClub = this.$route.params.id;
            club_fct.object.get(idClub, clubData=>{
                this.club = clubData;
                var idSeason = this.$route.params.idSeason;
                saison_fct.object.get(this.club, idSeason, seasonData=>{
                    this.season = seasonData;
                    if (seasonData.state=="FINISH") {
                        this.classements = seasonData.classements
                    }
                    else {
                        saison_fct.object.classement (this.club, this.$route.params.idSeason, classementData=>{
                            var classementModif = 1;
                            var classementEgalite = true;
                        
                            classementData.forEach((dataItem, indexData)=>{
                                if (!classementEgalite)
                                    classementModif = indexData+1;
                                dataItem.classement = classementModif;
                                 if (indexData < classementData.length-1) {
                                    var currentItem = classementData[indexData];
                                    var currentItemNext = classementData[indexData+1];
                                    
                                    if (currentItem.points != currentItemNext.points) {
                                        classementModif ++;
                                        classementEgalite = false;
                                    }
                                        
                                    else if (currentItem.diff != currentItemNext.diff) {
                                        classementModif ++;  
                                            classementEgalite = false;    
                                    }
                                    else
                                            classementEgalite = true;
                                }
                            })
                            
                            this.classements = classementData;

                        })
                    }
                })
            })
           
        },
        formatDate(date) {
            var options = { year: "numeric", month: "2-digit", day: "2-digit"};
            return (new Date(date)).toLocaleString("fr-Fr",options);
        },
        openModalClassement(classement) {
            this.openClassement = true;
            this.classementSelected = classement;
        },
        cloture() {
            
            saison_fct.object.cloture(this.club, this.$route.params.idSeason, this.classements);
            this.confirmCloturer = false;
        },
        close() {
            this.$router.push({name: "tournoisSeason" , params: {id: this.club.id, idSeason: this.$route.params.idSeason}});
        }
        
    }
}
</script>